/**
 * Companion model lookup — shared by the registry (labels), the
 * thinking-effort map and the vision check, so none of them has to reach
 * into the store itself.
 */

import { useCompanionStore } from "@/stores/companion-store";
import type { AvailableModel } from "@/stores/companion-store";

/**
 * Look up an AvailableModel by id across all companion-reported runtimes,
 * including alias matches. Returns null when no runtime has the model yet.
 */
export function findCompanionModel(modelValue: string): AvailableModel | null {
  const { availableModels } = useCompanionStore.getState();
  for (const runtime of Object.keys(availableModels)) {
    const list = availableModels[runtime];
    if (!list) continue;
    const direct = list.find((m) => m.id === modelValue);
    if (direct) return direct;
    const aliased = list.find((m) => (m.aliases ?? []).includes(modelValue));
    if (aliased) return aliased;
  }
  return null;
}
